export default __webpack_public_path__ + "static/media/logo_eng_crop.822d678b.jpg";